const getFunctionUrl = () => `${import.meta.env?.VITE_SUPABASE_URL}/functions/v1/ab-test-event`;

const getVisitorId = () => {
  const key = 'ab-experiment-visitor-id';
  try {
    const existing = localStorage.getItem(key);
    if (existing) return existing;
    const created = crypto?.randomUUID?.() || `visitor-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(key, created);
    return created;
  } catch {
    return `visitor-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
};

const request = async (payload) => {
  const response = await fetch(getFunctionUrl(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${import.meta.env?.VITE_SUPABASE_ANON_KEY}`,
    },
    body: JSON.stringify({ ...payload, visitorId: getVisitorId() }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data?.error || 'Experiment unavailable');
  return data;
};

export const resolveExperiment = (testId) => request({ action: 'resolve', testId });

export const trackExperimentClick = ({ testId, variantId, formId, visitorId }) =>
  request({
    action: 'track',
    testId,
    variantId,
    formId,
    eventType: 'click',
    ...(visitorId ? { visitorId } : {}),
  }).catch(() => null);

export const getExperimentVisitorId = getVisitorId;